export enum MfeType {
	WEB_COMPONENT = 'web-component',
}

export interface WebComponentManifest {
	type: MfeType;
	remoteEntry: string;
	elementName: string;
	connectedToChassisRoute?: boolean;
	shouldClearQueryParams?: boolean;
}
